import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, ArrowRight } from 'lucide-react';
import { siteMeta, projects } from '../mock';
import { toast } from '../hooks/use-toast';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    const list = JSON.parse(localStorage.getItem('etta_subs') || '[]');
    list.push({ email, at: new Date().toISOString() });
    localStorage.setItem('etta_subs', JSON.stringify(list));
    setEmail('');
    toast({
      title: 'Welcome to the porch.',
      description: 'We\u2019ll send stories from the farm, not spam.',
    });
  };

  return (
    <footer id="contact" className="relative bg-olive-deep text-cream-soft">
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="font-script text-6xl leading-none text-cream-soft/90">
            till next time
          </p>
          <h3 className="font-display text-4xl lg:text-5xl mt-2 leading-tight">
            Stay a while.
          </h3>
          <p className="font-serif text-lg mt-4 max-w-md text-cream-soft/80">
            Connect with me to create real life and brand stories.
          </p>

          <form onSubmit={handleSubscribe} className="mt-8 flex items-stretch max-w-md border-b border-cream-soft/40">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="bg-transparent flex-1 py-3 outline-none placeholder:text-cream-soft/50 font-serif text-base"
              required
            />
            <button
              type="submit"
              className="flex items-center gap-2 text-[11px] tracking-[0.24em] uppercase font-semibold hover:text-gold transition-colors"
            >
              Subscribe <ArrowRight size={16} strokeWidth={1.5} />
            </button>
          </form>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[11px] tracking-[0.24em] uppercase text-cream-soft/60 mb-4">Explore</div>
          <ul className="space-y-2 font-serif text-lg">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><a href="/#about" className="hover:text-gold transition-colors">About</a></li>
            <li><a href="/#projects" className="hover:text-gold transition-colors">Projects</a></li>
            <li><a href="#contact" className="hover:text-gold transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-[11px] tracking-[0.24em] uppercase text-cream-soft/60 mb-4">Projects</div>
          <ul className="space-y-2 font-serif text-lg">
            {projects.map((p) => (
              <li key={p.slug}>
                <Link to={`/projects/${p.slug}`} className="hover:text-gold transition-colors">
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>

          <div id="more" className="mt-10 flex items-center gap-4">
            <a href="#" aria-label="Instagram" className="p-2 rounded-full border border-cream-soft/30 hover:border-gold hover:text-gold transition-colors">
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a href={`mailto:${siteMeta.email}`} aria-label="Email" className="p-2 rounded-full border border-cream-soft/30 hover:border-gold hover:text-gold transition-colors">
              <Mail size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-cream-soft/15">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-display italic text-xl">.{siteMeta.brand}.</div>
          <div className="text-[11px] tracking-[0.24em] uppercase text-cream-soft/60">
            © {new Date().getFullYear()} {siteMeta.brand} · {siteMeta.location}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
